import React, { useContext, useEffect, useState } from "react";
import ContainerComponent from "../../../components/Container/ContainerComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import { AuthContext } from "../../../provider/auth/AuthContext";
import { usuarioService } from "../../../service/UsuarioService";
import { PedidoUsuarioDTO } from "../../../interface/Pedido";
import BoxComponent from "../../../components/Box/BoxComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { formatDate } from "../../../utils/datas";
import { ReactComponent as PedidosIcon } from "../../../assets/icons/pedidos.svg";
import { ReactComponent as CurrencyIcon } from "../../../assets/icons/currency.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import SvgComponent from "../../../components/Image/SvgComponent";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";
import ModalDetalhesItemPedidoComponent from "./components/item/ModalDetalhesInfoPedidoComponent";

interface ModalInfoPedidoProps {
    open: boolean;
    pedido?: PedidoUsuarioDTO;
}

const CatalogoPedidosUsuarioPage = () => {
    const { cliente, tokenCliente } = useContext(AuthContext);
    const [pedidosUsuario, setPedidosUsuario] = useState<PedidoUsuarioDTO[]>([]);

    const [modalInfoPedido, setModalInfoPedido] = useState<ModalInfoPedidoProps>({
        open: false,
        pedido: undefined
    });

    const handleOpenModalInfoPedido = (pedido: PedidoUsuarioDTO) => {
        setModalInfoPedido({
            ...modalInfoPedido,
            open: true,
            pedido
        });
    }

    const handleCloseModalInfoPedido = () => {
        setModalInfoPedido({
            ...modalInfoPedido,
            open: false,
            pedido: undefined
        });
    }

    useEffect(() => {
        if (tokenCliente != null && cliente != null && cliente.id !== undefined) getPedidosUsuario(cliente.id, tokenCliente);
    }, []);

    const getPedidosUsuario = async (id: number, tokenCliente: string) => {
        try {
            const data = await usuarioService.getPedidosUsuario(id, tokenCliente);
            setPedidosUsuario(data);
        } catch (e) {
            console.error(e);
        }
    }

    const handleClickPedido = (pedido: PedidoUsuarioDTO) => {
        handleOpenModalInfoPedido(pedido);
    }

    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: "center",
            pt: 2,
            overflow: "hidden"
            //mt: -6
        }}
    >
        <ModalDetalhesItemPedidoComponent
            open={modalInfoPedido.open}
            pedido={modalInfoPedido.pedido}
            onClose={handleCloseModalInfoPedido}
        />

        <BoxComponent component="header" sx={{ display: "flex", flexDirection: "column", }}>
            <TypographyComponent
                variant="h1"
                sx={{
                    fontFamily: '"Font 2", sans-serif',
                    fontWeight: 700,
                    fontSize: '30px',
                    lineHeight: '36px',
                    letterSpacing: '0%',
                    color: '#101828',
                    display: 'flex',
                    alignItems: 'center',
                    opacity: 1,
                }}
            >
                Meus Pedidos
            </TypographyComponent>

            <TypographyComponent
                variant="body2"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0%',
                    color: '#4A5565',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle'
                }}
            >
                Histórico de pedidos de {cliente?.nome}
            </TypographyComponent>
        </BoxComponent>

        <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 2, overflow: "auto" }}>
            {pedidosUsuario.length > 0 && pedidosUsuario.map((element: PedidoUsuarioDTO, index: number) => {
                return <ButtonComponent
                    id={`item-pedido-${element.id}`}
                    key={`item-pedido-${element.id}`}
                    onClick={() => handleClickPedido(element)}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: '#FFFFFF',

                        boxShadow: `
                      0px 2px 4px -2px rgba(0, 0, 0, 0.10), 
                      0px 4px 6px -1px rgba(0, 0, 0, 0.10)
                    `,
                        cursor: 'pointer',
                        transition: 'none',

                        '&:active': {
                            backgroundColor: '#F9FAFB',
                        },
                        p: 2,
                        gap: 1.5
                    }}>
                    <BoxComponent component="div" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    letterSpacing: '0%',
                                    color: '#4A5565',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: "none"
                                }}
                            >
                                Pedido #{element.id}
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    lineHeight: '28px',
                                    letterSpacing: '0%',
                                    color: '#101828',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: "none"
                                }}
                            >
                                {formatDate(new Date(element.dataPedido))}
                            </TypographyComponent>
                        </BoxComponent>
                        <BoxComponent component="div">
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    width: '90px',
                                    height: '28px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '4px 12px',
                                    borderRadius: '35791400px',
                                    backgroundColor: '#FEF9C2',
                                    opacity: 1,
                                    boxSizing: 'border-box',
                                    textTransform: "none",
                                    color: "#A65F00"
                                }}
                            >
                                {element.status}
                            </TypographyComponent>
                        </BoxComponent>
                    </BoxComponent>

                    <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", width: "100%", gap: 1.5 }}>
                        <BoxComponent component="div" sx={{ display: "flex", gap: 1.5 }}>
                            {/* QUANTIDADE DE ITENS */}
                            <BoxComponent component="div" sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <SvgComponent
                                    icon={<PedidosIcon />}
                                    sx={{
                                        display: "flex",
                                        alignpropss: "center",
                                        justifyContent: "center",
                                        height: 16,
                                        width: 16,
                                        "& svg, & svg *": {
                                            stroke: "#4A5565",
                                        },
                                    }}
                                />
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '24px',
                                        letterSpacing: '0%',
                                        color: '#4A5565',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: "none"
                                    }}
                                >
                                    {element.itens.length} item(ns)
                                </TypographyComponent>
                            </BoxComponent>

                            {/* VALOR */}
                            <BoxComponent component="div" sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <SvgComponent
                                    icon={<CurrencyIcon />}
                                    sx={{
                                        display: "flex",
                                        alignpropss: "center",
                                        justifyContent: "center",
                                        height: 16,
                                        width: 16,
                                        "& svg, & svg *": {
                                            stroke: "#4A5565",
                                        },
                                    }}
                                />
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 700,
                                        fontSize: '16px',
                                        lineHeight: '24px',
                                        letterSpacing: '0%',
                                        color: '#101828',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: "none"
                                    }}
                                >
                                    {formatNumberToDinheiro(element.valor)}
                                </TypographyComponent>
                            </BoxComponent>
                        </BoxComponent>

                        {/* MAIORES DETALHES */}
                        <BoxComponent component="div">
                            <SvgComponent
                                icon={<PlayIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    height: 16,
                                    width: 16,
                                    "& svg, & svg *": {
                                        fill: "#4A5565"
                                    },
                                }}
                            />
                        </BoxComponent>

                    </BoxComponent>
                </ButtonComponent>
            })}
        </BoxComponent>

    </ContainerComponent>
}

export default CatalogoPedidosUsuarioPage;